export default __webpack_public_path__ + "static/media/appdemo.df0417d7.png";